/* Fresh Suds - cart reassurance (Oct 27 2026, Deputy; CRO move 1).
   Adds two short lines under the checkout buttons of the Rebuy Smart Cart: the guarantee sentence (canon wording) and a contact line.
   THEME ONLY: nothing is changed in Rebuy's dashboard. The cart's own markup is untouched; we append one <div class="fs-cart-assure"> after the
   checkout buttons and put it back if Rebuy re-draws the footer.
   No phone number (none is published). To remove: delete the <script> line in layout/theme.liquid and this file.
   If the same lines are ever added in Rebuy's own "Custom Code Block", remove this file so the cart does not show them twice. */
(function () {
  'use strict';
  var GUARANTEE = 'Not happy within 90 days? Full refund — and keep the bar.';
  var MAIL = 'customerservice@freshsudssoapery.ca';
  var CLS = 'fs-cart-assure';
  var observed = null, observer = null, timer = null;

  function addStyle() {
    if (document.getElementById('fs-cart-assure-css')) return;
    var s = document.createElement('style');
    s.id = 'fs-cart-assure-css';
    s.textContent =
      '.' + CLS + '{margin:10px 0 2px;text-align:center;color:var(--fs-ink,#073033)}' +
      '.' + CLS + ' p{margin:0;font-size:14px;line-height:1.4}' +
      '.' + CLS + '__g{font-weight:600}' +
      '.' + CLS + '__q{margin-top:4px!important;color:#4A5A58}' +
      '.' + CLS + ' a{color:inherit;text-decoration:underline;text-underline-offset:2px;display:inline-block;padding:10px 2px;margin:-10px -2px}';
    document.head.appendChild(s);
  }

  function build() {
    var box = document.createElement('div');
    box.className = CLS;
    var g = document.createElement('p');
    g.className = CLS + '__g';
    g.textContent = GUARANTEE;
    var q = document.createElement('p');
    q.className = CLS + '__q';
    q.appendChild(document.createTextNode('Questions? Email us at '));
    var a = document.createElement('a');
    a.href = 'mailto:' + MAIL;
    a.textContent = MAIL;
    q.appendChild(a);
    box.appendChild(g);
    box.appendChild(q);
    return box;
  }

  function ensure() {
    var flyout = document.querySelector('.rebuy-cart__flyout');
    if (flyout && flyout !== observed) attach(flyout);
    var btn = document.querySelector('.rebuy-cart__flyout .rebuy-cart__checkout-button');
    if (!btn || !btn.parentElement) return;
    var wrap = btn.parentElement;
    if (wrap.querySelector('.' + CLS)) return;
    wrap.appendChild(build());
  }

  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; ensure(); }, 60);
  }

  function attach(flyout) {
    if (observer) observer.disconnect();
    observed = flyout;
    if (window.MutationObserver) {
      observer = new MutationObserver(schedule);
      observer.observe(flyout, { childList: true, subtree: true });
    }
  }

  function start() {
    addStyle();
    ensure();
    ['rebuy:smartcart.show', 'rebuy:cart.change', 'rebuy:cart.add', 'rebuy:smartcart.ready'].forEach(function (n) {
      document.addEventListener(n, schedule);
    });
    /* Rebuy mounts its cart a little after load; look for it for up to 60 s, then stop (events above still re-check). */
    var tries = 0;
    var iv = setInterval(function () {
      ensure();
      if (observed || ++tries > 120) clearInterval(iv);
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
